module.exports = __webpack_public_path__ + "static/media/SideBySide-Whatfix.4a252df8.svg";